import {
  Flame,
  Gift,
  Headphones,
  Home,
  MessageCircle,
  Megaphone,
  Sparkles,
  Timer,
  Trophy,
  Zap,
  type LucideIcon,
} from 'lucide-react';

export type PlatformKey = 'ca28' | 'pg' | 'cq' | 'fg' | 'bg';

export interface HomePlatformTheme {
  key: PlatformKey;
  code: string;
  shortCode: string;
  name: string;
  title: string;
  description: string;
  tag: string;
  quickLabel: string;
  panel: string;
  frame: string;
  action: string;
  metric: string;
  glow: string;
  accent: string;
  icon: LucideIcon;
}

export const homePlatformThemes: Record<PlatformKey, HomePlatformTheme> = {
  ca28: {
    key: 'ca28',
    code: '28',
    shortCode: '28',
    name: '加拿大28',
    title: '开奖房间大厅',
    description: '热门房间、开奖节奏、互动竞猜入口集中展示',
    tag: '数字竞猜',
    quickLabel: '数字竞猜',
    panel: 'from-[#330707] via-[#9d1c13] to-[#2a0509]',
    frame: 'from-amber-300 via-rose-500 to-red-500',
    action: 'from-amber-100 via-orange-300 to-yellow-400 text-[#3a1600]',
    metric: 'from-violet-500/80 to-fuchsia-500/70',
    glow: 'shadow-[0_0_30px_rgba(251,113,60,0.34)]',
    accent: '#fbbf24',
    icon: Timer,
  },
  pg: {
    key: 'pg',
    code: 'PG',
    shortCode: 'PG',
    name: 'PG SOFT',
    title: '正版高爆电子',
    description: '热门机台、官方大厅、锦标赛入口集中展示',
    tag: 'RNG 正版认证',
    quickLabel: 'PG 电子',
    panel: 'from-[#21033f] via-[#5a20a9] to-[#160f36]',
    frame: 'from-fuchsia-400 via-violet-500 to-purple-400',
    action: 'from-fuchsia-200 via-violet-300 to-purple-400 text-[#25063f]',
    metric: 'from-blue-500/80 to-indigo-500/70',
    glow: 'shadow-[0_0_30px_rgba(168,85,247,0.36)]',
    accent: '#d946ef',
    icon: Sparkles,
  },
  cq: {
    key: 'cq',
    code: 'CQ9',
    shortCode: 'CQ',
    name: 'CQ9',
    title: '亚洲精品电玩',
    description: '多题材电子娱乐，快速启动体验更轻',
    tag: '热门亚洲馆',
    quickLabel: 'CQ9 电玩',
    panel: 'from-[#3b0904] via-[#a42413] to-[#350704]',
    frame: 'from-orange-400 via-red-500 to-rose-500',
    action: 'from-orange-200 via-orange-400 to-red-400 text-[#3b1005]',
    metric: 'from-cyan-500/80 to-sky-500/70',
    glow: 'shadow-[0_0_30px_rgba(249,115,22,0.32)]',
    accent: '#fb923c',
    icon: Flame,
  },
  fg: {
    key: 'fg',
    code: '5G',
    shortCode: '5G',
    name: '5G Gaming',
    title: '新潮娱乐大厅',
    description: '移动端优先的轻量游戏体验，入口更直接',
    tag: '极速开局',
    quickLabel: '5G 游戏',
    panel: 'from-[#031d3f] via-[#0754b8] to-[#03204a]',
    frame: 'from-cyan-300 via-blue-500 to-sky-400',
    action: 'from-cyan-200 via-blue-300 to-sky-400 text-[#041c3f]',
    metric: 'from-rose-500/80 to-pink-500/70',
    glow: 'shadow-[0_0_30px_rgba(14,165,233,0.34)]',
    accent: '#38bdf8',
    icon: Zap,
  },
  bg: {
    key: 'bg',
    code: 'BG',
    shortCode: 'BG',
    name: 'BG Video',
    title: '真人视讯大厅',
    description: '视讯桌台、真人互动、快速进入大厅',
    tag: '真人视讯',
    quickLabel: 'BG 视讯',
    panel: 'from-[#042f2e] via-[#0f766e] to-[#042f2e]',
    frame: 'from-emerald-300 via-teal-500 to-cyan-400',
    action: 'from-emerald-100 via-teal-300 to-cyan-300 text-[#042f2e]',
    metric: 'from-amber-500/80 to-orange-500/70',
    glow: 'shadow-[0_0_30px_rgba(20,184,166,0.34)]',
    accent: '#2dd4bf',
    icon: Trophy,
  },
};

export const serviceTiles = [
  { title: '聊天室', subtitle: '互动入口', icon: MessageCircle },
  { title: '客服大厅', subtitle: '互动入口', icon: Headphones },
  { title: '福利活动', subtitle: '互动入口', icon: Gift },
  { title: '公告中心', subtitle: '互动入口', icon: Megaphone },
] as const;

export const metricIcons = {
  platform: Sparkles,
  game: Trophy,
  room: Home,
  hot: Flame,
};
